import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';
import { accessLocalStorage } from '../../../services';

import Loading from '../../../components/Loading/LoadingModule';

import '../../../libs/bulma.min.css';
import './InternalCallsView.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPen, faArrowLeft, faCopy, faCheck, faPhone, faCog, faList, faClock } from '@fortawesome/free-solid-svg-icons';

function InternalCallsView() {
  const getItensStateGlobal = useContext(PbxContext);
  const { itemsSelectedToEdit, toggleIsChangeFormElements, toggleIsHidden, setItemsSelectedToEdit } = getItensStateGlobal;

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [copiedField, setCopiedField] = useState(null);

  const validateUserLogged = useCallback(async () => {
    const dataUser = await accessLocalStorage.getUserLocalStorage();
    if (!dataUser) return history.push('/');
    
    // Verificar se há dados para visualizar
    if (!itemsSelectedToEdit || !itemsSelectedToEdit.id) {
      return history.push('/config/chamadas/internas');
    }

    setLoading(false);
  }, [history, itemsSelectedToEdit]);

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  const handleEdit = () => {
    toggleIsChangeFormElements();
    toggleIsHidden();
    history.push('/config/chamadas/internas/editar');
  };

  const copyToClipboard = async (text, fieldName) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedField(fieldName);
      setTimeout(() => setCopiedField(null), 2000);
    } catch (err) {
      console.error('Erro ao copiar para área de transferência:', err);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString('pt-BR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  const getStatusColor = (isActive) => {
    return isActive ? 'is-success' : 'is-danger';
  };

  const getStatusText = (isActive) => {
    return isActive ? 'Ativo' : 'Inativo';
  };

  const getDestinationTypeColor = (type) => {
    switch (type) {
      case 'endpoint': return 'is-success';
      case 'queue': return 'is-warning';
      case 'disa': return 'is-danger';
      default: return 'is-light';
    }
  };

  const getDestinationTypeText = (type) => {
    switch (type) {
      case 'endpoint': return 'Endpoint (Ramal)';
      case 'queue': return 'Queue (Fila)';
      case 'disa': return 'DISA (Goto)';
      default: return type || 'Não definido';
    }
  };

  const getOverflowTypeColor = (type) => {
    switch (type) {
      case 'endpoint': return 'is-success';
      case 'queue': return 'is-warning';
      case 'cycle': return 'is-info';
      default: return 'is-light';
    }
  };

  const getOverflowTypeText = (type) => {
    switch (type) {
      case 'endpoint': return 'Endpoint';
      case 'queue': return 'Queue';
      case 'cycle': return 'Ciclo';
      default: return type || 'Não definido';
    }
  };

  // Funções auxiliares para regras GotoIfTime
  const formatTimeRange = (timeRange) => {
    if (timeRange === '*') return 'Sempre';
    return timeRange;
  };

  const formatDaysOfWeek = (daysOfWeek) => {
    const daysMap = {
      '*': 'Todos os dias',
      'mon-fri': 'Segunda à Sexta',
      'sat-sun': 'Sábado e Domingo',
      'mon': 'Segunda-feira',
      'tue': 'Terça-feira',
      'wed': 'Quarta-feira',
      'thu': 'Quinta-feira',
      'fri': 'Sexta-feira',
      'sat': 'Sábado',
      'sun': 'Domingo'
    };
    return daysMap[daysOfWeek] || daysOfWeek;
  };

  const formatDaysOfMonth = (daysOfMonth) => {
    const daysMap = {
      '*': 'Todos os dias',
      '1-15': 'Dia 1 ao 15',
      '16-31': 'Dia 16 ao 31',
      '1': 'Dia 1',
      '15': 'Dia 15',
      '30': 'Dia 30',
      '31': 'Dia 31'
    };
    return daysMap[daysOfMonth] || daysOfMonth;
  };

  const formatMonths = (months) => {
    const monthsMap = {
      '*': 'Todos os meses',
      'jan-mar': 'Janeiro a Março',
      'apr-jun': 'Abril a Junho',
      'jul-sep': 'Julho a Setembro',
      'oct-dec': 'Outubro a Dezembro',
      'jan': 'Janeiro',
      'feb': 'Fevereiro',
      'mar': 'Março',
      'apr': 'Abril',
      'may': 'Maio',
      'jun': 'Junho',
      'jul': 'Julho',
      'aug': 'Agosto',
      'sep': 'Setembro',
      'oct': 'Outubro',
      'nov': 'Novembro',
      'dec': 'Dezembro'
    };
    return monthsMap[months] || months;
  };

  if (loading) return <Loading />;

  const config = itemsSelectedToEdit;

  return (
    <div className="internal-calls-view-container">
      <div className="internal-calls-view-header">
        <div className="internal-calls-view-title-wrapper">
          <svg className="internal-calls-view-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          <div>
            <h1 className="internal-calls-view-title">Visualizar Configuração</h1>
            <p className="internal-calls-view-subtitle">Configuração #{config.id}</p>
          </div>
        </div>
        <div className="internal-calls-view-actions">
          <button 
            className="btn-action-view btn-edit-view"
            onClick={handleEdit}
          >
            <FontAwesomeIcon icon={faPen} />
            Editar
          </button>
          <Link to="/config/chamadas/internas" className="btn-action-view btn-back-view">
            <FontAwesomeIcon icon={faArrowLeft} />
            Voltar
          </Link>
        </div>
      </div>

      <div className="details-grid">
        <div className="details-card">
          <h2 className="details-section-title">
            <FontAwesomeIcon icon={faPhone} className="details-section-icon" />
            Informações Gerais
          </h2>
                  
          <div className="detail-field">
            <label className="detail-label">ID da Configuração</label>
            <div className="detail-value">
              <strong>#{config.id}</strong>
              <button 
                className={`copy-button ${copiedField === 'id' ? 'copied' : ''}`}
                onClick={() => copyToClipboard(config.id.toString(), 'id')}
              >
                <FontAwesomeIcon icon={copiedField === 'id' ? faCheck : faCopy} />
                {copiedField === 'id' ? ' Copiado!' : ' Copiar'}
              </button>
            </div>
          </div>

          <div className="detail-field">
            <label className="detail-label">Tenant</label>
            <div className="detail-value">
              <span className="detail-value-badge badge-tenant">{config.tenant || 'N/A'}</span>
            </div>
          </div>

          <div className="detail-field">
            <label className="detail-label">Máscara</label>
            <div className="detail-value">
              <span className="detail-value-badge badge-mask">{config.mask || 'Não definido'}</span>
            </div>
            <p className="detail-value-help">Padrão interceptado pela configuração</p>
          </div>

          <div className="detail-field">
            <label className="detail-label">Destino Principal</label>
            <div className="detail-value">
              {config.destination_main || 'Não definido'}
              <button 
                className={`copy-button ${copiedField === 'destination_main' ? 'copied' : ''}`}
                onClick={() => copyToClipboard(config.destination_main, 'destination_main')}
              >
                <FontAwesomeIcon icon={copiedField === 'destination_main' ? faCheck : faCopy} />
              </button>
            </div>
            <p className="detail-value-help">Destino principal da chamada</p>
          </div>

          <div className="detail-field">
            <label className="detail-label">Tipo de Destino</label>
            <div className="detail-value">
              <span className={`detail-value-badge ${
                config.destination_type_main === 'endpoint' ? 'badge-endpoint' :
                config.destination_type_main === 'queue' ? 'badge-queue' :
                config.destination_type_main === 'disa' ? 'badge-disa' : 'badge-light'
              }`}>
                {getDestinationTypeText(config.destination_type_main)}
              </span>
            </div>
            <p className="detail-value-help">Aplicação utilizada no Asterisk</p>
          </div>

          <div className="detail-field">
            <label className="detail-label">Configuração Dinâmica</label>
            <div className="detail-value">
              <span className={`detail-value-badge ${config.is_dynamic ? 'badge-active' : 'badge-light'}`}>
                {config.is_dynamic ? 'Sim' : 'Não'}
              </span>
            </div>
            <p className="detail-value-help">Utiliza transbordos automáticos</p>
          </div>

          <div className="detail-field">
            <label className="detail-label">Status</label>
            <div className="detail-value">
              <span className={`detail-value-badge ${config.active ? 'badge-active' : 'badge-inactive'}`}>
                {getStatusText(config.active)}
              </span>
            </div>
            <p className="detail-value-help">Estado atual da configuração</p>
          </div>
        </div>

        <div className="details-card details-card-full">
          <h2 className="details-section-title">
            <FontAwesomeIcon icon={faList} className="details-section-icon" />
            Transbordos Configurados
          </h2>
                  
          {config.overflows && config.overflows.length > 0 ? (
            <ul className="overflow-list">
              {config.overflows.map((overflow, index) => (
                <li key={index} className="overflow-item-view">
                  <div className="overflow-item-title">
                    Transbordo #{index + 1} - <span className={`detail-value-badge ${
                      overflow.destination_type === 'endpoint' ? 'badge-endpoint' :
                      overflow.destination_type === 'queue' ? 'badge-queue' :
                      overflow.destination_type === 'cycle' ? 'badge-cycle' : 'badge-light'
                    }`}>
                      {getOverflowTypeText(overflow.destination_type)}
                    </span>
                  </div>
                  <div className="overflow-item-details">
                    <div className="overflow-detail">
                      <span className="overflow-detail-label">Timeout</span>
                      <span className="overflow-detail-value">
                        <FontAwesomeIcon icon={faClock} /> {overflow.timeout}s
                      </span>
                    </div>
                    <div className="overflow-detail">
                      <span className="overflow-detail-label">Destino</span>
                      <span className="overflow-detail-value">
                        {overflow.destination_overflow || 'Não definido'}
                        <button 
                          className={`copy-button ${copiedField === `overflow_${index}` ? 'copied' : ''}`}
                          onClick={() => copyToClipboard(overflow.destination_overflow, `overflow_${index}`)}
                        >
                          <FontAwesomeIcon icon={copiedField === `overflow_${index}` ? faCheck : faCopy} />
                        </button>
                      </span>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <div className="detail-value-empty">
              <p style={{ textAlign: 'center', padding: '2rem' }}>
                <strong>Nenhum transbordo configurado</strong><br />
                Esta configuração utiliza apenas o destino principal.
              </p>
            </div>
          )}
        </div>

        <div className="details-card details-card-full">
          <h2 className="details-section-title">
            <FontAwesomeIcon icon={faClock} className="details-section-icon" />
            Regras de Horário (GotoIfTime)
          </h2>
          
          {config.gotoiftime_rules && config.gotoiftime_rules.length > 0 ? (
            <>
              <p className="detail-value-help" style={{ marginBottom: '1.5rem' }}>
                Regras de desvio baseadas em data e hora. Executadas em sequência antes da chamada principal.
              </p>
              
              <ul className="time-condition-list">
                {config.gotoiftime_rules.map((rule, index) => (
                  <li key={index} className="time-condition-item">
                    <div className="time-condition-title">
                      Regra #{index + 1} - Ordem: {rule.sequence_order || index + 1}
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem', marginTop: '1rem' }}>
                            <div className="column is-6">
                              <div className="field">
                                <label className="label is-small">⏰ Horário</label>
                                <div className="control">
                                  <input 
                                    className="input is-small" 
                                    type="text" 
                                    value={formatTimeRange(rule.time_range)}
                                    readOnly 
                                  />
                                  <span className="icon is-small is-right">
                                    <button 
                                      className="button is-small is-ghost"
                                      onClick={() => copyToClipboard(rule.time_range, `gotoif_time_${index}`)}
                                    >
                                      <FontAwesomeIcon 
                                        icon={copiedField === `gotoif_time_${index}` ? faCheck : faCopy} 
                                        className={copiedField === `gotoif_time_${index}` ? 'has-text-success' : 'has-text-grey'}
                                      />
                                    </button>
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div className="column is-6">
                              <div className="field">
                                <label className="label is-small">📅 Dias da Semana</label>
                                <div className="control">
                                  <input 
                                    className="input is-small" 
                                    type="text" 
                                    value={formatDaysOfWeek(rule.days_of_week)}
                                    readOnly 
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Linha 2: Dias do Mês e Meses */}
                          <div className="columns">
                            <div className="column is-6">
                              <div className="field">
                                <label className="label is-small">📆 Dias do Mês</label>
                                <div className="control">
                                  <input 
                                    className="input is-small" 
                                    type="text" 
                                    value={formatDaysOfMonth(rule.days_of_month)}
                                    readOnly 
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="column is-6">
                              <div className="field">
                                <label className="label is-small">🗓️ Meses</label>
                                <div className="control">
                                  <input 
                                    className="input is-small" 
                                    type="text" 
                                    value={formatMonths(rule.months)}
                                    readOnly 
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Linha 3: Destino */}
                          <div className="columns">
                            <div className="column is-4">
                              <div className="field">
                                <label className="label is-small">🎯 Contexto de Destino</label>
                                <div className="control">
                                  <input 
                                    className="input is-small" 
                                    type="text" 
                                    value={rule.context_name || 'Não definido'}
                                    readOnly 
                                  />
                                  <span className="icon is-small is-right">
                                    <button 
                                      className="button is-small is-ghost"
                                      onClick={() => copyToClipboard(rule.context_name, `gotoif_context_${index}`)}
                                    >
                                      <FontAwesomeIcon 
                                        icon={copiedField === `gotoif_context_${index}` ? faCheck : faCopy} 
                                        className={copiedField === `gotoif_context_${index}` ? 'has-text-success' : 'has-text-grey'}
                                      />
                                    </button>
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div className="column is-4">
                              <div className="field">
                                <label className="label is-small">📞 Extensão</label>
                                <div className="control">
                                  <input 
                                    className="input is-small" 
                                    type="text" 
                                    value={rule.extension_name || 'Não definido'}
                                    readOnly 
                                  />
                                  <span className="icon is-small is-right">
                                    <button 
                                      className="button is-small is-ghost"
                                      onClick={() => copyToClipboard(rule.extension_name, `gotoif_ext_${index}`)}
                                    >
                                      <FontAwesomeIcon 
                                        icon={copiedField === `gotoif_ext_${index}` ? faCheck : faCopy} 
                                        className={copiedField === `gotoif_ext_${index}` ? 'has-text-success' : 'has-text-grey'}
                                      />
                                    </button>
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div className="column is-4">
                              <div className="field">
                                <label className="label is-small">🔢 Prioridade</label>
                                <div className="control">
                                  <span className="tag is-info">
                                    {rule.priority || 1}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Descrição da Regra */}
                          {rule.description && rule.description.trim() !== '' && (
                            <div className="field">
                              <label className="label is-small">📝 Descrição</label>
                              <div className="control">
                                <input 
                                  className="input is-small" 
                                  type="text" 
                                  value={rule.description}
                                  readOnly 
                                />
                              </div>
                            </div>
                          )}

                          {/* Destino Final Formatado */}
                          <div className="field">
                            <label className="label is-small">🚀 Comando GotoIfTime</label>
                            <div className="control">
                              <input 
                                className="input is-small has-background-grey-lighter" 
                                type="text" 
                                value={`GotoIfTime(${rule.time_range},${rule.days_of_week},${rule.days_of_month},${rule.months}?${rule.context_name},${rule.extension_name},${rule.priority || 1})`}
                                readOnly 
                                style={{ fontFamily: 'monospace', fontSize: '0.75rem' }}
                              />
                              <span className="icon is-small is-right">
                                <button 
                                  className="button is-small is-ghost"
                                  onClick={() => copyToClipboard(`GotoIfTime(${rule.time_range},${rule.days_of_week},${rule.days_of_month},${rule.months}?${rule.context_name},${rule.extension_name},${rule.priority || 1})`, `gotoif_full_${index}`)}
                                >
                                  <FontAwesomeIcon 
                                    icon={copiedField === `gotoif_full_${index}` ? faCheck : faCopy} 
                                    className={copiedField === `gotoif_full_${index}` ? 'has-text-success' : 'has-text-grey'}
                                  />
                                </button>
                              </span>
                            </div>
                            <p className="help is-size-7">
                              Comando Asterisk que será executado no dialplan
                            </p>
                          </div>
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <div className="detail-value-empty">
              <p style={{ textAlign: 'center', padding: '2rem' }}>
                <strong>Nenhuma regra de horário configurada</strong><br />
                Esta configuração não possui desvios baseados em data/hora.
              </p>
            </div>
          )}
        </div>

        {config.description && config.description.trim() !== '' && (
          <div className="details-card details-card-full">
            <h2 className="details-section-title">
              📝 Descrição
            </h2>
            <div className="detail-value-text">
              {config.description}
            </div>
            <p className="detail-value-help">
              {config.description.length}/500 caracteres
            </p>
          </div>
        )}

        <div className="details-grid">
          <div className="details-card">
            <h2 className="details-section-title">
              <FontAwesomeIcon icon={faCog} className="details-section-icon" />
              Informações Técnicas
            </h2>
            
            <div className="detail-field">
              <label className="detail-label">Criado em</label>
              <div className="detail-value">{formatDate(config.created_at)}</div>
            </div>

            <div className="detail-field">
              <label className="detail-label">Atualizado em</label>
              <div className="detail-value">{formatDate(config.updated_at)}</div>
            </div>

            <div className="detail-field">
              <label className="detail-label">Total de Transbordos</label>
              <div className="detail-value">
                <span className="detail-value-badge badge-destination">
                  {config.overflows ? config.overflows.length : 0} transbordo(s)
                </span>
              </div>
            </div>

            <div className="detail-field">
              <label className="detail-label">Total de Regras de Horário</label>
              <div className="detail-value">
                <span className="detail-value-badge" style={{ background: 'rgba(243, 156, 18, 0.1)', color: '#f39c12' }}>
                  <FontAwesomeIcon icon={faClock} /> {config.gotoiftime_rules ? config.gotoiftime_rules.length : 0} regra(s)
                </span>
              </div>
            </div>
          </div>

          <div className="details-card">
            <h2 className="details-section-title">
              💡 Informações
            </h2>
            <div style={{ fontSize: '0.9rem', lineHeight: '1.8' }}>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                <li><strong>Máscara:</strong> Padrão interceptado pelo Asterisk</li>
                <li><strong>Destino Principal:</strong> Primeiro destino da chamada</li>
                <li><strong>Endpoint:</strong> Usa Dial() no Asterisk</li>
                <li><strong>Queue:</strong> Usa Queue() no Asterisk</li>
                <li><strong>DISA:</strong> Usa Goto() no Asterisk</li>
                <li><strong>Dinâmica:</strong> Executa transbordos em sequência</li>
                <li><strong>Ciclo:</strong> Reinicia o fluxo evitando hangup</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InternalCallsView;